import styled from 'styled-components';

import Picture from 'components/picture';

const StyledPicture = styled(Picture)`
  flex-shrink: 0;
  max-height: 30vh;
  max-width: 30vh;
  margin: 0 auto;
`;

export default StyledPicture;
